<div fxLayout="row" fxLayoutAlign="space-between center" matDialogTitle>
  <span>Programming Chart</span>
  <button mat-icon-button matDialogClose>&times;</button>
</div>
<mat-dialog-content>
<img src="assets/images/programming_chart.png" style="width: 900px;">
</mat-dialog-content>
